export const DEV_DOMAIN = process.env.REACT_APP_ENV === 'dev' ? 'https://keyhole-v3.webflow.io' : ''
